import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import { SettingsService } from '@dxp/core/services';

@Component({
    selector: 'telxl-container-overlay',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './container-overlay.component.html',
    styleUrl: './container-overlay.component.scss',
})
export class TelXLContainerOverlayComponent {
    readonly #settingsService = inject(SettingsService);

    topOpacity = input('0.5');
    overlayBackground = input('108,117,125');
    isOverlayVisible = input<boolean>(false);
    bottomValue = computed(() =>
        (this.#settingsService.chatFooterHeight() + 2).toString().concat('px'),
    );

    opacity = computed(
        () => `rgb(${this.overlayBackground()}, ${this.topOpacity()})`,
    );
}
